<template src="@/templates/dashboard/jobsDashboard.html"></template>

<script>
    import JobsCollection from "@/collections/jobsCollection";
    import OutstandingInvoiceChart from '@/components/dashboard/charts/OutstandingInvoices'
    import JobsChart from '@/components/dashboard/charts/Jobs'
    import moment from 'moment'

    export default {
        name: "Dashboard",
        components: {
            OutstandingInvoiceChart, JobsChart
        },
        data() {
            return {
                title: "",
                JobsCollection: new JobsCollection,
                showSpinner: true,
                isResize: false,
                languagesChartValues: [],
                languagesChartValuesItem: [],
                languagesLegendName: [],
                languagesLegendNameItem: [],
                languagesNoteHeader: 'Top 10 Languages',
                jobsByTypeChartValues: [],
                jobsByTypeLegendName: [],
                jobsByTypeNoteHeader: 'Jobs By Type',
                jobsByStatusChartValues: [],
                jobsByStatusLegendName: [],
                jobsByStatusNoteHeader: 'Jobs By Status',
                jobsByLocationChartValues: [],
                jobsByLocationLegendName: [],
                jobsByLocationNoteHeader: 'Top Locations',
                jobsByClockOnStatusChartValues: [],
                jobsByClockOnStatusLegendName: [],
                jobsByClockOnStatusNoteHeader: 'Jobs By Clocked On Status'
            }
        },
        created() {
            this.getJobsInformation();
            this.title = 'Client usage data from 01 Jul ' + this.financialYear('Start') + ' to ' + '30 Jun ' + this.financialYear('End');
        },
        mounted() {
            let resizeId;
            let thisComponent = this;
            window.addEventListener('resize', function () {
                clearTimeout(resizeId);
                resizeId = setTimeout(thisComponent.doneResizing, 500);
            });
        },
        methods: {
            doneResizing() {
                this.isResize = true;

                if (this.$browserDetect.isSafari) {
                    setTimeout(function () {
                        window.location.reload();
                    }, 500);
                    return;
                }

                this.$router.go(0);
            },
            linkToOutstandingInvoicesReport() {
                this.$router.push('/OutstandingInvoices');
            },
            linkToJobsReport(reportFor) {
                this.$router.push({name: "reportJobs", query: {reportFor: reportFor}});
            },
            getJobsInformation() {
                let url = this.$localApiURL + this.JobsCollection.getRoute('getJobsInformation') + "?&token=" + localStorage.getItem('jwt');
                this.$http.get(url).then((response) => {
                    if (response.data !== null && response.data !== {}) {
                        this.JobsCollection.models = response.data.data;
                        this.setTop10Languages();
                        this.setJobsByType();
                        this.setJobsByStatus();
                        this.setJobsByClockOnStatus();
                        this.setJobsByLocation();
                    } else {
                        this.JobsCollection.models = [];
                    }

                    this.showSpinner = false;
                }).catch((error) => {
                    console.error(error);
                });
            },
            setTop10Languages() {

                let languagesCV = Object.values(this.JobsCollection.models.languages);
                let languagesLN = Object.values(Object.keys(this.JobsCollection.models.languages));

                languagesCV.forEach((item) => {
                    this.languagesChartValues.unshift([item]);
                });

                languagesLN.forEach((item) => {
                    this.languagesLegendName.unshift([item]);
                });
            },
            setJobsByType() {
                this.jobsByTypeChartValues = Object.values(this.JobsCollection.models.jobsByType);
                this.jobsByTypeLegendName = Object.values(Object.keys(this.JobsCollection.models.jobsByType));
            },
            setJobsByStatus() {
                let jobsByStatusCV = Object.values(this.JobsCollection.models.jobsByStatus);
                let jobsByStatusLN = Object.values(Object.keys(this.JobsCollection.models.jobsByStatus));

                jobsByStatusCV.forEach((item) => {
                    this.jobsByStatusChartValues.unshift([item]);
                });

                jobsByStatusLN.forEach((item) => {
                    this.jobsByStatusLegendName.unshift([item]);
                });
            },
            setJobsByClockOnStatus() {
                this.jobsByClockOnStatusChartValues = Object.values(this.JobsCollection.models.jobsByClockOnStatus);
                this.jobsByClockOnStatusLegendName = Object.values(Object.keys(this.JobsCollection.models.jobsByClockOnStatus));
            },
            setJobsByLocation() {
                let jobsByLocationCV = Object.values(this.JobsCollection.models.jobsByLocation);
                let jobsByLocationLN = Object.values(Object.keys(this.JobsCollection.models.jobsByLocation));

                jobsByLocationCV.forEach((item) => {
                    this.jobsByLocationChartValues.unshift([item]);
                });

                jobsByLocationLN.forEach((item) => {
                    
                    if(item.length > 30){
                        item = item.substring(0,30) + "...";
                    }
                    this.jobsByLocationLegendName.unshift([item]);
                });
            },
            financialYear(identifier) {

                let month = parseInt(moment().format("M"));
                let year = parseInt(moment().format("Y"));

                if (month < 7) {
                    if (identifier === 'Start') {
                        return year - 1;
                    }
                    else {
                        return year;
                    }
                }

                if (month < 13) {
                    if (identifier === 'Start') {
                        return year;
                    }
                    else {
                        return year + 1;
                    }
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/JobsDashboardComponent.vue